exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".font-change,.v-app,.v-application,body,html{font-size:10pt;font-family:ABCFavorit,system-ui,sans-serif!important}.pagebreak{page-break-after:always;min-height:1px}.force-full-height{height:100vh!important;width:100vw!important}.tearline{border-bottom:1px dashed #ccc}@page{size:letter portrait}@media print{.address-windows{position:fixed;top:5.8cm;left:2cm}}", ""]);

// exports
